import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import { ThemeProvider } from 'react-jss';
import { observer } from 'mobx-react';
import { ReactNotifications } from 'react-notifications-component';
import { useFullscreen } from 'react-use';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { ToastProvider } from 'react-toast-notifications';
import { TourProvider } from '@reactour/tour';

import axios from 'axios';

import firebase from 'firebase/app';

import { ReactChannelIO } from 'react-channel-plugin';

import { getCurrentBrowserFingerPrint } from '@rajesh896/broprint.js';

import { useTranslation } from 'react-i18next';

import moment from 'moment-timezone';

import { browserName } from 'react-device-detect';

import ThemeContext from './contexts/themeContext';
import Aside from './layout/Aside/Aside';
import Wrapper from './layout/Wrapper/Wrapper';
import Portal from './layout/Portal/Portal';
import { demoPages, extraMenu, layoutMenu, pawsswordFind } from './menu';
import { Toast, ToastContainer } from './components/bootstrap/Toasts';
import useDarkMode from './hooks/useDarkMode';
import COLORS from './common/data/enumColors';
import steps, { styles } from './steps';
import { Provider, rootStore } from './models';
import firebaseInit from './firebaseInit';
import { getItem, setItem } from './lib/localstorage';
import { Configs } from './models/Configs';

import { getOS } from './helpers/helpers';

import config from './config';
import Alert from './components/bootstrap/Alert';
import { moveLoginPage } from './lib/Util';
import { useLocalStorageWatcher } from 'hooks/useLocalStorageWatcher';
import FooterRoutes from 'layout/Footer/FooterRoutes';
import Logo from 'components/Logo_v2';
import HeaderRoutes from 'layout/Header/HeaderRoutes';

moment.tz.setDefault('Asia/Seoul');

/** ****************************************************************
 * 파일명 : frontend2\src\App.js
 * 메뉴 :
 * URL  :
 * 설명 : 메타타임 React의 App.js
 ***************************************************************** */

if (process.env.NODE_ENV === "development") {
	console.log("Env Mode:", process.env.REACT_APP_ENV);
	console.log("Node Environment:", process.env.NODE_ENV);
	console.log("API URL:", config.API_URL);
}

const App = observer(() => {
	const location = useLocation();
	const { t, i18n } = useTranslation();
	const navigate = useNavigate();
	// const { user, company } = useMst();

	const [webToken, setwebToken] = useState(getItem('webToken'));
	// const webToken = getItem('webToken');

	let messaging = null;
	if (firebase.messaging.isSupported()) {
		messaging = firebaseInit.messaging();
	}

	const getFireBaseMessaging = async () => {
		messaging
			.requestPermission({
				alert: true,
				badge: true,
				sound: true,
				announcement: true,
			})
			.then(async function () {
				// console.warn('get Toekn?', messaging.getToken());
				const token = await messaging.getToken();
				console.warn('webToken:', token);
				return token; // 토큰을 받는 함수를 추가!
			})
			.then(function (token) {
				// console.warn('SET TOKEN');
				if (!token) return;
				localStorage.setItem('tokenFireBase', token);
				setItem('webToken', token);
				setwebToken(token);
				Configs.setFcm(token).then(() => {
					if (Configs.fcmCode && Configs.uuid && rootStore.user.me.id > 0) {
						Configs.sendDevice();
					}
				});
			})
			.catch(function (err) {
				console.warn('fcm에러 : ', err);
			});

		messaging.onTokenRefresh(function () {
			messaging
				.getToken()
				.then(function (refreshedToken) {
					// console.warn('SET REFRESH TOKEN');
					if (!refreshedToken) return;
					console.warn('webToken-refreshed:', refreshedToken);
					setItem('webToken', refreshedToken);
					setwebToken(refreshedToken);
					Configs.setFcm(refreshedToken).then(() => {
						if (Configs.fcmCode && Configs.uuid && rootStore.user.me.id > 0) {
							Configs.sendDevice();
						}
					});
					// console.warn('Token refreshed.');
				})
				.catch(function () {
					// console.warn('Unable to retrieve refreshed token ', err);
				});
		});
	};

	useEffect(() => {
		// console.warn('webToken', webToken, Configs.get);

		if (firebase.messaging.isSupported()) {
			if ((!webToken || webToken === '') && messaging) {
				// console.warn('get Toekn');
				getFireBaseMessaging();
			}
		}

		// console.warn(webToken)
		// if(webToken !== '') {
		// 	Configs.setFcm(webToken).then(()=>{
		// 		Configs.sendDevice();
		// 	})
		// }

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [webToken]);

	const [notification, setNotification] = useState('');
	useEffect(() => {
		const requestNotification = () => {
			console.warn('agent', window.navigator);

			if (!('Notification' in window)) {
				setNotification(null);
				console.warn('not support notification');
			} else if (Notification.permission !== 'granted') {
				Notification.requestPermission().then(async (permission) => {
					console.warn('permission', permission);
					if (permission === 'granted') {
						setNotification(true);
						if (firebase.messaging.isSupported()) {
							if (messaging) {
								getFireBaseMessaging();
							}
						}
						console.warn('ok notification');
					} else {
						setNotification(false);
						console.warn('no notification');
					}
				});
			} else {
				setNotification(true);
				console.warn('ok notification');
			}
		};
        // 앱 환경인지
		const isAppEnvironment = window.flutter_inappwebview && typeof window.flutter_inappwebview.callHandler === 'function';

		const resolveUuid = async () => {
			if (isAppEnvironment) {
				try {
					const deviceInfo = await window.flutter_inappwebview.callHandler('DeviceInfo');
					if (deviceInfo && deviceInfo.success && deviceInfo.deviceId) {
						return deviceInfo.deviceId;
					}
				} catch (e) {
					console.warn('deviceInfo 오류, fingerprint 가져올예정', e);
				}
			}
			return getCurrentBrowserFingerPrint();
		};

		const getIpOs = async () => {
			const os = getOS();
			await Promise.all([
				resolveUuid().then((uuid) => {
					console.log('uuid', uuid);
					Configs.setUuid(uuid);
				}),
				axios.get('https://api.ipify.org/?format=json').then((res) => {
					// console.warn('set public Ip', res.data)
					Configs.setPublicIp(res.data.ip);
					// console.warn('res.data', res.data);
				}),
				Configs.setOs(os),
			]);
		};
		getIpOs();
		requestNotification();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	/**
	 * Dark Mode
	 */
	const { themeStatus, darkModeStatus } = useDarkMode();
	const theme = {
		theme: themeStatus,
		primary: COLORS.PRIMARY.code,
		secondary: COLORS.SECONDARY.code,
		success: COLORS.SUCCESS.code,
		info: COLORS.INFO.code,
		warning: COLORS.WARNING.code,
		danger: COLORS.DANGER.code,
		dark: COLORS.DARK.code,
		light: COLORS.LIGHT.code,
	};

	useEffect(() => {
		if (darkModeStatus) {
			document.documentElement.setAttribute('theme', 'dark');
		}
		return () => {
			document.documentElement.removeAttribute('theme');
		};
	}, [darkModeStatus]);

	/**
	 * Full Screen
	 */
	const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
	const ref = useRef(null);
	useFullscreen(ref, fullScreenStatus, {
		onClose: () => setFullScreenStatus(false),
	});

	/**
	 * Modern Design
	 */
	useLayoutEffect(() => {
		if (process.env.REACT_APP_MODERN_DESGIN === 'true') {
			document.body.classList.add('modern-design');
		} else {
			document.body.classList.remove('modern-design');
		}
	});

	//	Add paths to the array that you don't want to be "Aside".
	const withOutAsidePages = [
		demoPages.login.path,
		demoPages.signUp.path,
		pawsswordFind.PasswdReset.path,
		layoutMenu.blank.path,
		extraMenu.changeCompany.path,
		demoPages.azureLoginCallback.path,
		demoPages.azureLogin.path,
		demoPages.simpleSso.path,
		demoPages.simpleLogin.path,
		demoPages.simplePasswordLogin.path,
		demoPages.pubLayout.path,
	];

	useEffect(() => {
		// AUTH 확인
		// console.warn('>>', location);
		if (withOutAsidePages.findIndex((v) => `/${v}` === location.pathname) === -1) {
			rootStore.user.authMe().then((data)	=> {
				if(rootStore.user.me.id === 0) {
					navigate('/'+demoPages.login.path, {state: location.pathname});
				}
				if(!data.currentCompanyId) {
					navigate('/change-company');
				}
				// 각 필요한 값 기본 세팅.
				if(rootStore.company.get.id > 0) {
					// 공지사항
					// 알림개수
				}
			});
		}
		// console.warn('auth me', demoPages.login.path)
		// console.warn('rootStore', rootStore.user.me)

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	useEffect(() => {
		if (!Configs.publicIp) return;
		// AUTH 확인

		
		if (withOutAsidePages.findIndex((v) => `/${v}` === location.pathname) === -1) {
			rootStore.user.authMe().then((data) => {
				if(rootStore.user.me.id === 0) {
					moveLoginPage();
					return;
				}
				if (!data.currentCompanyId) {
					navigate('/change-company');
				}
				// 각 필요한 값 기본 세팅.
				if (rootStore.company.get.id > 0) {
					// 공지사항
					// 알림개수
				}
			});
		}
		// console.warn('auth me', demoPages.login.path)
		// console.warn('rootStore', rootStore.user.me)

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [Configs.publicIp]);

	// useEffect(() => {
	// 	console.warn('ROOT 강제 렌더링')
	// 	forceUpdate();
	// 	// navigate(0);
	// 	// window.location.reload();
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [lang])

	const [dontShowAgain] = useLocalStorageWatcher('dontShowAgain');

	// 페이지 구분하는 클래스 추가
	useEffect(() => {
		const pathClassMap = {
			'/login': 'login_page',
			'/PasswdReset' : 'password_page',
			'/change-company' : 'change_company_page'
		}

		const className = pathClassMap[location.pathname];

		document.body.classList.remove(...Object.values(pathClassMap));

		if(className){
			document.body.classList.add(className);
		}
	}, [location.pathname]);

	useEffect(() => {

			window.updateLocation = function (latitude, longitude) {
					console.log("window.updateLocation ==> latitude: ", latitude, ", longitude: ", longitude);
			};

	}, []);

	// 사용자 배경화면 가져오기
	const prevBgClassRef = useRef(null);

	useEffect(() => {
		const rootEl = document.getElementById('root');
		const newClass = rootStore.user?.me?.backGroundImg;

		// 직전에 붙였던 class가 있고, 새 값과 다르면 먼저 제거 => 클래스 중복되지 않게
		if (prevBgClassRef.current && prevBgClassRef.current !== newClass) {
			rootEl.classList.remove(prevBgClassRef.current);
		}

		if (newClass) {
			rootEl.classList.add(newClass);
			prevBgClassRef.current = newClass;
		}else{
			// 만약 기본 배경을 바꾸게 된다면 BackgroundSetContent.js의 기본 배경 값도 바꿔줘야 함
			rootEl.classList.add('bgStemp01');
		}
	}, [rootStore.user?.me?.backGroundImg]);

	return (
		<>
		{!i18n.isInitialized ? null : // i18n 로딩 전 key 노출(깜빡임) 방지
		(
			<Provider value={rootStore}>
				<ThemeProvider theme={theme}>
					<ToastProvider components={{ ToastContainer, Toast }}>
						<ReactChannelIO pluginKey="f6ab6cd6-b8ca-4c74-92fc-fc24bd34d62c" hideChannelButtonOnBoot={true} language="ko" autoBoot autoBootTimeout={2000}>
							<TourProvider steps={steps} styles={styles} showNavigation={false} showBadge={false}>
								{notification !== true && notification !== '' && browserName.includes('Safari') && (
									!dontShowAgain ?
										<div className='dont-show-again  12'>
											<Alert rounded={0} color="danger" borderWidth={0} className="d-flex justify-content-center small fw-bold text-white">
												{t('common.validation.notiPermissIsnotAvailable')}
											</Alert>
										</div>
										: <></>

								)}

								{notification !== true && notification !== '' && !browserName.includes('Safari')
									/*
									&& (
									<div className='dont-show-again 11'>
										<Alert rounded={0} color="danger" borderWidth={0} className="d-flex justify-content-center small fw-bold text-white">
											{t('common.validation.notiPermissIsnotAvailable')}
										</Alert>
									</div>
								)
									*/
								}
								<div
									ref={ref}
									className='app'
									style={{
										backgroundColor: fullScreenStatus && 'var(--bs-body-bg)',
										zIndex: fullScreenStatus && 1,
										overflow: fullScreenStatus && 'scroll',
									}}
								>
									<div className='app_header'>
										<div className='brand-logo'>
											<h1 className='brand-title'>
												<Logo height={60} />
											</h1>
										</div>
										<HeaderRoutes />
									</div>
									<Routes>
										{withOutAsidePages.map((path) => (
											<Route key={path} path={path} />
										))}
										<Route path="*" element={<Aside />} />
									</Routes>
									<Wrapper />
								</div>
								<FooterRoutes />
								<Portal id="portal-notification">
									<ReactNotifications />
								</Portal>
							</TourProvider>
						</ReactChannelIO>
					</ToastProvider>
				</ThemeProvider>
			</Provider>
		)}
		</>
	);
});

export default App;